import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const CuetLoginPage = () => {
    const [creds, setCreds] = useState({ applicationNo: '', password: '' });
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/mock-cuet/login', creds);
            if(res.data.success) {
                // Save mock session locally
                localStorage.setItem('mockCuetUser', JSON.stringify(res.data.data));
                navigate('/services/counselling/dashboard');
            }
        } catch(err) {
            alert(err.response?.data?.message || 'Login Failed');
        }
    };

    return (
        <div className="container contentmid">
            <div className="col-md-6 col-md-offset-3">
                <div className="panel panel-primary">
                    <div className="panel-heading">Candidate Login</div>
                    <div className="panel-body">
                        <form onSubmit={handleLogin}>
                            <div className="form-group">
                                <label>Application No</label>
                                <input type="text" className="form-control" onChange={(e)=>setCreds({...creds, applicationNo: e.target.value})} required/>
                            </div>
                            <div className="form-group">
                                <label>Password</label>
                                <input type="password" className="form-control" onChange={(e)=>setCreds({...creds, password: e.target.value})} required/>
                            </div>
                            <button type="submit" className="btn btn-primary btn-block">Login</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CuetLoginPage;